import { useState, useEffect } from "react";
import SelectBox from "../../../../../utils/components/SelectBox";
import Input from "../../../../../utils/components/Input";
import Textarea from "../../../../../utils/components/Textarea";

const StepInfo = ({ step, users, handleAction, translate }) => {
  const [personsToBeInformed, setPersonsToBeInformed] = useState([]);
  const [textTitle, setTextTitle] = useState(
    step.settings.step_info.info_title || ""
  );
  const [textContent, setTextContent] = useState(
    step.settings.step_info.info_description || ""
  );

  const findUsersById = () => {
    let selectedUsers = [];
    step.settings.step_info.info_users.forEach((userId) => {
      const user = users.find((user) => user.user_id === userId);
      if (user) {
        selectedUsers.push({
          id: user.user_id,
          value: user.user_id.toString(),
          label: user.user_name,
        });
      }
    });
    setPersonsToBeInformed(selectedUsers);
  };

  useEffect(() => {
    findUsersById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleAction("step_info", {
      personsToBeInformed,
      textTitle,
      textContent,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personsToBeInformed, textTitle, textContent]);

  return (
    <div>
      <div className="row d-flex align-items-end mt-3">
        <div className="col-11">
          <p className="text-gray text-uppercase fw-bold mb-2">
            {translate(
              "design_approval_process.uppercase_translates.input_titles.persons-to-be-informed"
            )}
          </p>
          <SelectBox
            options={users.map((user) => ({
              id: user.user_id,
              value: user.user_id.toString(),
              label: user.user_name,
            }))}
            onChange={(value) => setPersonsToBeInformed(value)}
            placeholder={translate(
              "design_approval_process.step-edit-modal.placeholders.select-persons-to-be-informed"
            )}
            isMulti={true}
            value={personsToBeInformed}
          />
        </div>
      </div>
      <div className="row d-flex align-items-center mt-3">
        <div className="col-11">
          <p className="text-gray text-uppercase fw-bold mb-2">
            {translate(
              "design_approval_process.uppercase_translates.input_titles.text-title"
            )}
          </p>
          <Input
            type="text"
            placeholder={translate(
              "design_approval_process.step-edit-modal.placeholders.text-title"
            )}
            onChange={(e) => setTextTitle(e.target.value)}
            value={textTitle}
          />
        </div>
      </div>
      <div className="row d-flex align-items-center mt-3">
        <div className="col-11">
          <p className="text-gray text-uppercase fw-bold mb-2">
            {translate(
              "design_approval_process.uppercase_translates.input_titles.text-content"
            )}
          </p>
          <Textarea
            placeholder={translate(
              "design_approval_process.step-edit-modal.placeholders.text-content"
            )}
            onChange={(e) => setTextContent(e.target.value)}
            value={textContent}
            rows={4}
          />
        </div>
      </div>
    </div>
  );
};
export default StepInfo;
